import { PxdAgGridColumnTypes, PxdAgGridDefaultColumnDef, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from '@app/shared/aggrid/pxd-ag-grid-options';
import { ValueSetterParams } from 'ag-grid-community';

export const assetMappingMultiAssetAvailablesGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  rowSelection: { mode: 'multiRow' },
  columnDefs: [
    { field: 'AssetId', type: ['numberColumn'] },
    { field: 'AssetName', type: ['textColumn'] },
    { field: 'AssetType', type: ['textColumn'] },
    { field: 'CostCenterNumber', type: ['numberColumn'] },
    { field: 'CostCenterType', type: ['textColumn'] }
  ]
};

export const assetMappingMultiAssetMappedGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  rowSelection: { mode: 'multiRow' },
  columnDefs: [
    { field: 'AssetId', type: ['numberColumn'] },
    { field: 'Asset.AssetName', headerName: 'Asset Name', type: ['textColumn'] },
    { field: 'Asset.AssetType.Description', headerName: 'Type', type: ['textColumn'] },
    { field: 'Asset.CostCenter.CostCenterNumber', headerName: 'Cost Center ID', type: ['numberColumn'] },
    { field: 'Asset.CostCenter.CostCenterType.Description', headerName: 'Cost Center', type: ['textColumn'] },
    { field: 'Asset.County.Description', headerName: 'County', type: ['textColumn'] },
    { field: 'Asset.State.Description', headerName: 'State', type: ['textColumn'] },
    {
      field: 'Asset.IsInsideCityLimits',
      headerName: 'Inside City Limits',
      cellRenderer: 'pxdAgGridCheckboxRendererReadOnly'
    },
    {
      field: 'PercentAllocation',
      editable: true,
      type: ['numberColumn'],
      valueSetter: (params: ValueSetterParams) => {
        var newValInt = Number(params.newValue);
        var valueChanged = params.oldValue !== newValInt;
        if (valueChanged) {
          params.data.PercentAllocation = newValInt != null ? newValInt : params.oldValue;
        }
        return valueChanged;
      },
      valueFormatter: params => params.value.toLocaleString('en-US', { style: 'percent', maximumFractionDigits: 6, minimumFractionDigits: 0 })
    }
  ]
};  